import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 35px;
  left: calc(50% - 120px);
  transform: translateX(-50%);
  width: 800px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;

  font-size: 36px;
  color: #ffff66; /* yellowish */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), -2px -2px 4px rgba(0, 0, 0, 0.9); /* classic subtitle shadow */
  text-align: center;
  font-weight: bold;
  line-height: 1.3;

  background: transparent;
  border: none;
  pointer-events: none; /* so it doesn't block clicks if it's an overlay */
`;
